import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import CopyrightIcon from '@material-ui/icons/Copyright';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';

import Icon from '@components/Icon/Icon';
import Link from '@components/Link/Link';

import './Footer.scss';
import '@components/Link/Link.scss';

const Footer = () => (
  <div className="footer">
    <div className="footer__section">
      <div className="footer__item">
        <Icon className="footer__icon">
          <CopyrightIcon />
        </Icon>
        <div>
          Process General
        </div>
      </div>
    </div>
    <div className="footer__section">
      <div className="footer__item">
        <RouterLink
          to="/terms-of-use"
          className="link"
        >
          Terms of Use
        </RouterLink>
      </div>
      <div className="footer__item">
        <RouterLink
          to="/privacy-policy"
          className="link"
        >
          Privacy Policy
        </RouterLink>
      </div>
    </div>
    <div className="footer__section">
      <div className="footer__item">
        <Icon className="footer__icon">
          <EmailIcon />
        </Icon>
        <div>
          <Link href="mailto:info@processgeneral.com">
            info@processgeneral.com
          </Link>
        </div>
      </div>
      <div className="footer__item">
        <Icon className="footer__icon">
          <PhoneIcon />
        </Icon>
        <div>
          855.485.4850
        </div>
      </div>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/routes/components/Footer/Footer.js